import styled from "styled-components";

export const ActivityNewsWidgetStyled = styled.div`
  margin: auto;
  margin-bottom: 20px;
  .activity_news_header {
    margin-bottom: 30px;
    .activity_news_text {
      margin-bottom: 2px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_11};
      font-size: ${({ theme }) => theme.FONT.SIZE.S26};
      font-family: ${({ theme }) =>
        theme.FONT.STYLE.GT_AMERICA_COMPRESSED_BOLD};
    }
    .liner {
      margin: auto;
      border-top: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      width: 50px;
    }
  }
  .activity_news_list {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    .activity_news_item {
      flex-basis: calc(50% - 10px);
    }
  }
  .discover_more_button_wrap {
    display: flex;
    justify-content: center;
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .activity_news_header {
      margin-bottom: 30px;
    }
    .activity_news_list {
      margin-bottom: 30px;
      column-gap: 16px;
      row-gap: 20px;
    }
  }
`;
